import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import * as config from '../config';
import { titleToId } from './../utils'

class StructuredData extends React.Component {

  render() {
    let { title, image, created, updated, isReview, pagePath, isBreadcrumbs, products, introduction } = this.props;
    image = image || '../image/logo.svg';
    const jsonLd = [this.getWebSiteScript(), this.getOrganizationScript()];
    if (isBreadcrumbs) {
      jsonLd.push(this.getBreadcrumbsScript(pagePath, title))
    }
    if (isReview) {
      jsonLd.push(this.getBlogPostingScript(pagePath, title, image, created, updated, introduction))
      jsonLd.push(this.getCriticReviews(pagePath, title, image, products, created))
    }
    return (
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
    )
  }

  getWebSiteScript = () => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'WebSite',
      url: config.siteUrl,
      name: config.organizationName,
      description: config.siteDescription
    };
  };


  getOrganizationScript = () => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'Organization',
      url: config.siteUrl,
      name: config.organizationName,
      logo: config.logoIcon,
      sameAs: config.socialLinks
    };
  };

  getBreadcrumbsScript = (pagePath, title) => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          item: {
            '@id': config.startPageUrl,
            name: config.startPageName
          }
        },
        {
          "@type": "ListItem",
          position: 2,
          item: {
            '@id': config.siteUrl + pagePath,
            name: title
          }
        },
      ],
    }
  };

  getBlogPostingScript = (pagePath, title, image, created, updated, introduction) => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'BlogPosting',
      url: config.siteUrl + pagePath,
      datePublished: created,
      dateModified: updated,
      headline: title,
      description: introduction,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': config.siteUrl + pagePath
      },
      image: {
        '@type': 'ImageObject',
        url: config.siteUrl + image,
      },
      author: {
        '@type': "Person",
        name: config.authorName
      },
      publisher: {
        '@type': 'Organization',
        name: config.organizationName,
        logo: {
          '@type': 'ImageObject',
          url: config.logoIconPublisher,
          height: 50,
          width: 200
        },
      },
    };
  };

  getCriticReviews = (pagePath, title, image, products, created) => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'ItemList',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': config.siteUrl + pagePath
      },
      name: title,
      itemListOrder: 'Ascending',
      itemListElement: products.map((product, index) => {
        if (index === 0) {
          // skip first product.
          return;
        }
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            "@context": "https://schema.org/",
            "@type": "Review",
            datePublished: created,
            reviewBody: product.prons ? product.prons.join(', ') : '',
            name: product.subtitle,
            url: config.siteUrl + pagePath + '#' + titleToId(product.title),
            author: {
              "@type": "Person",
              name: config.authorName,
            },
            "publisher": {
              "@type": "Organization",
              name: config.organizationName,
              sameAs: config.socialLinks,
              logo: config.logoIcon,
            },
            inLanguage: 'en',
            itemReviewed: {
              "@context": "https://schema.org/",
              "@type": "Product",
              name: product.title,
              description: product.subtitle,
              image: {
                '@type': 'ImageObject',
                url: config.siteUrl + product.image,
              },
              review: {
                reviewBody: product.prons ? product.prons.join(', ') : '',
                name: product.title,
                author: {
                  "@type": "Person",
                  name: config.authorName,

                },
              },
            }
          }
        }
      })
    };
  };
}

export default StructuredData;

StructuredData.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  created: PropTypes.string,
  updated: PropTypes.string,
  isReview: PropTypes.bool,
  pagePath: PropTypes.string,
  isBreadcrumbs: PropTypes.bool,
  products: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/structured-data.js